
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tema/[slug]",
      function () {
        return require("private-next-pages/tema/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tema/[slug]"])
      });
    }
  